/**
 * beszélget a mifiddel
 * @author sarkiroka on 2017.11.28.
 */
import axios from 'axios';

export default {
	init() {
		return axios.get('/apps/mifid/api/data');
	},
	getMasterData(selectedValues) {
		return axios.post('/apps/mifid/api/data', selectedValues);
	},
	calculate(selectedValues) {
		return axios.post('/apps/mifid/api/calculator', selectedValues);
	}
};
